import { useMemo } from 'react';
import { ScopeEnum } from 'src/domain';
import { useScope } from 'src/hooks';
import { useSalesCampaigns } from 'src/hooks/sales-campaigns-planning/useSalesCampaigns';
import { useStores } from 'src/hooks/store-selection/queries/useStores';
import { mapStyleTimelineDataToOverviewRows } from 'src/mapping/style-timeline.mapping';
import { useStyleTimelineQuery } from '../queries/useStyleTimelineQuery';

export const useStyleTimelineRows = (selectedStorefrontType?: string) => {
    const { styleTimelines, collections, styleCategories, loading, error } =
        useStyleTimelineQuery(selectedStorefrontType);
    const scope = useScope();
    const { data } = useStores();
    const {
        data: salesCampaigns,
        loading: salesCampaignsLoading,
        error: salesCampaignsError,
    } = useSalesCampaigns({
        enabled: scope === ScopeEnum.PARTNER,
    });

    const rows = useMemo(() => {
        const overviewRows = mapStyleTimelineDataToOverviewRows(
            styleTimelines,
            collections,
            salesCampaigns,
            styleCategories,
            data.allStores,
            scope === ScopeEnum.GLOBAL
        );
        return overviewRows;
    }, [styleTimelines, collections, salesCampaigns, styleCategories, data.allStores, scope]);

    return {
        data: rows,
        collections,
        salesCampaigns,
        loading: loading || salesCampaignsLoading,
        error: error ?? salesCampaignsError,
    };
};
